<template>
	<div>
		<div class="table-wrapper">
			<table class="table">
				<thead>
					<tr>
						<th v-if="on_select != undefined" class="pointer" style="width: 30px;" @click="on_select('all')">
							<i v-if="selected.length == list.length" class="fas fa-fw fa-check-square"></i>
							<i v-if="selected.length != list.length" class="far fa-fw fa-square"></i>
						</th>
						<th v-for="(header, idx) in headers" :key="idx">
							<button v-if="ordering.includes(idx)" class="order" :class="{'active': (order_field == idx)}" @click="reorder(idx)">
								{{ header }}
								<i v-if="order_direction == 'DESC'" class="fa fa-fw fa-caret-up"></i>
								<i v-if="order_direction == 'ASC'"  class="fa fa-fw fa-caret-down"></i>
							</button>
							<button v-else class="order">
								{{ header }}
							</button>
						</th>
						<th>
							<button class="order">Opções</button>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="loading">
						<td :colspan="colspan" style="text-align: center;">
							<b><i class="fa fa-circle-notch fa-spin"></i> CARREGANDO INFORMAÇÕES...</b>
						</td>
					</tr>
					<tr v-else-if="!loading && list.length == 0">
						<td :colspan="colspan" style="text-align: center;">
							<b>NENHUM REGISTRO</b>
						</td>
					</tr>
					<tr v-else v-for="(item, idx) in list" :key="idx">
						<td v-if="on_select != undefined" class="pointer" @click="on_select(item.id)">
							<i v-if="selected.includes(item.id)" class="fas fa-fw fa-check-square"></i>
							<i v-if="!selected.includes(item.id)" class="far fa-fw fa-square"></i>
						</td>
						<td v-for="(header, idx) in headers" :key="idx" :title="item[idx]" v-html="item_modified(item[idx], idx, item)"></td>
						<td>
							<slot :item="item"></slot>
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td class="pagination" :colspan="colspan - 1">
							<div class="pagination-total">
								Mostrando {{ start }}-{{ end }} de {{ total }} resultados.
							</div>
						</td>
						<td v-if="!per_page"></td>
						<td class="pagination" style="min-width: 80px;" v-if="per_page">
							<button class="pagination-button" :disabled="!has_next" @click="next">
								<i class="fa fa-angle-right"></i>
							</button>
							<button class="pagination-button" :disabled="!has_prev" @click="prev">
								<i class="fa fa-angle-left"></i>
							</button>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Table",

		props: [ "loading", "headers", "ordering", "order", "list", "page", "per_page", "total", "modifiers", "on_select", "selected"],

		data: function() {
			return {};
		},
		

		computed: {
			order_field: function() {
				if (this.order) return this.order.split("-").shift();
				if (this.ordering && this.ordering.length > 0) return this.ordering[0];
				return false;
			},

			order_direction: function() {
				if (this.order) {
					const split = this.order.split("-");
					if (split.length > 1) return split[1];
				}
				return "DESC";
			},

			start: function() {
				if (this.list.length == 0) return 0;
				return (this.page * this.per_page) + 1;
			},

			end: function() {
				if (this.per_page == 0) {
					return this.total;
				}

				if (this.list.length < this.per_page) {
					return (this.page * this.per_page) + this.list.length;
				} else {
					return (this.page + 1) * this.per_page;
				}
			},

			has_next: function() {
				let last_page = Math.floor(this.total / this.per_page);
				return (this.page < last_page);
			},

			has_prev: function() {
				return (this.page > 0);
			},

			colspan: function() {
				let i = Object.keys(this.headers).length + 1;
				if (this.on_select !== undefined) i++;
				return i;
			},
		},

		methods: {
			item_modified: function(value, index, item) {
				if (this.modifiers && this.modifiers[index] != undefined) {
					return this.modifiers[index](value, item);
				}
				return value;
			},

			next: function() {
				this.$emit('next');
			},

			prev: function() {
				this.$emit('prev');
			},

			reorder: function(new_order) {
				if (new_order == this.order_field) {
					if (this.order_direction == "ASC") {
						new_order += "-DESC";
					} else {
						new_order += "-ASC";
					}
				} else {
					new_order += "-ASC";
				}

				this.$emit("reorder", new_order);
			}
		},
	}
</script>


<style scoped>

.table-wrapper {
	width: 100%;
}

.table {
	width: 100%;
	background: #fff;
	border-radius: 4px;
}

.table th, .table td {
	text-align: left;
	padding: 10px;
	font-size: 14px;
}

.table td {
	text-align: left;
	padding: 10px;
	border-top: 1px solid #f0f0f0;
	font-size: 14px;
}

table > tbody > tr:hover {
	background-color: #f0f0f0;
}


.order {
	background: none;
	border: none;
	color: #aaa;
}
.order.active {
	color: #222;
}




.pagination {
	border-top: 1px solid #f0f0f0;
}


.pagination-button {
	float: right;
	background: none;
	border: none;
	width: 30px;
	height: 30px;
	font-size: 20px;
	padding: 0;
	text-align: center;
	color: #999;
}
.pagination-button:disabled {
	color: #ddd;
}


.pagination-total {
	float: left;
	height: 40px;
	line-height: 45px;
	text-align: left;
}

</style>